import { render, staticRenderFns } from "./newOpen4.vue?vue&type=template&id=749587e2&scoped=true&"
import script from "./newOpen4.vue?vue&type=script&lang=js&"
export * from "./newOpen4.vue?vue&type=script&lang=js&"
import style0 from "./newOpen4.vue?vue&type=style&index=0&id=749587e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749587e2",
  null
  
)

export default component.exports